// Utility to merge site messages with theme default messages
const defaultMessages = require('../i18n/defaultMessages')

/**
 * Merges site-provided messages with theme default messages.
 * Site messages override theme defaults for the same key.
 * New languages or keys from site are added.
 *
 * @param {Object} siteMessages - Messages provided by the site (optional)
 * @returns {Object} Merged messages object
 */
const mergeMessages = (siteMessages = {}) => {
    const merged = {}

    // Get all language keys from both sources
    const allLangs = new Set([
        ...Object.keys(defaultMessages),
        ...Object.keys(siteMessages)
    ])

    for (const lang of allLangs) {
        merged[lang] = {
            ...(defaultMessages[lang] || {}),  // Theme defaults
            ...(siteMessages[lang] || {})       // Site overrides/extends
        }
    }

    return merged
}

module.exports = { mergeMessages, defaultMessages }